<template>
    <Modal
        v-if="showModal"
        @modal:close="premiumNudgeStore.hideModal"
        :maxWidth="'max-w-[690px]'"
        :hideActions="true"
        :preventScrolling="false"
    >
        <template #body>
            <h2 class="text-won-ash-gray text-[24px] leading-[100%] font-bold font-Inter">
                Select a Plan
            </h2>
            
            <div class="mt-4">
                <SubscriptionPurchaseOptions
                    :isSettings="true"
                    :allowExitToFreePlan="true"
                />
            </div>
        </template>
    </Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { usePremiumNudgeStore } from "../store/nudge-premium.store";

import SubscriptionPurchaseOptions from "../components/subscription-purchase-options.vue";
import Modal from "../components/modal.vue";

const premiumNudgeStore = usePremiumNudgeStore();
const { showModal } = storeToRefs(premiumNudgeStore);
</script>
